import { Link } from 'react-router-dom';
import { NAV_LINKS, POLICY_LINKS } from '../constants/content';
import { GUIDE_CATEGORIES, guidePath, guidesIn } from '../constants/guides';
import { ADDRESS_LINE1, ADDRESS_LINE2, COMPANY_NAME, SITE_DOMAIN, SITE_TAGLINE, HELPS_PHONE } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';
import Logo from './Logo';
import Ornament from './Ornament';

const PAGE_LINKS = NAV_LINKS.flatMap((link) => link.children || [link]);

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <Ornament light />
      </div>
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="brand brand--light">
            <Logo size={50} />
            <span className="brand__text">
              <span className="brand__name">AncestryHelp</span>
              <span className="brand__tag">Helps · Updates · Troubleshooting</span>
            </span>
          </Link>
          <p>{SITE_TAGLINE}. Real people helping you get back to discovering your family story.</p>
          <address>
            <strong>{COMPANY_NAME}</strong>
            <br />
            {ADDRESS_LINE1}
            <br />
            {ADDRESS_LINE2}
          </address>
          <button type="button" className="footer-chat" onClick={openZohoChat}>
            Chat with a technician →
          </button>
          {HELPS_PHONE ? (
            <p>
              <a href={HELPS_PHONE.tel}>{HELPS_PHONE.display}</a>
            </p>
          ) : null}
        </div>

        <div className="footer-col">
          <h2>The Site</h2>
          <ul>
            {PAGE_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h2>Popular Guides</h2>
          <ul>
            {GUIDE_CATEGORIES.map((cat) => {
              const [first] = guidesIn(cat.key);
              return (
                <li key={cat.key}>
                  <Link to={guidePath(first.slug)}>{first.title}</Link>
                </li>
              );
            })}
            <li>
              <Link to="/guides">All guides →</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h2>Policies</h2>
          <ul>
            {POLICY_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-legal">
        <div className="container">
          <p>
            <strong>Disclaimer:</strong> {SITE_DOMAIN} is an independent technical helps provider operated by{' '}
            {COMPANY_NAME}. We are not affiliated with, endorsed by, or sponsored by Ancestry.com, Ancestry.com
            Operations Inc., or any brand mentioned on this site. Ancestry offers its own official help centre on its
            website. Trademarks belong to their respective owners and are used only to describe the products we help with.
          </p>
          <p className="footer-legal__copy">
            © {year} {COMPANY_NAME}. All rights reserved. · <Link to="/">{SITE_DOMAIN}</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
